module.exports = __webpack_public_path__ + "banquet/components/Banquet/images/apple-touch-icon-152.68cd74815e538681d2f8e02edb7552a8.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Banquet/images/apple-touch-icon-152.png
// module id = 1657
// module chunks = 1